import { getRoute } from '@utils/route';

type RouteParams = {
  orderNumber: string;
  billingId: number;
};

export const CAR_QUOTE_PAYMENT_PAGE_URL = '/car-insurance-quote-payment/:orderNumber/:billingId';

export const routeCarQuotePaymentPage = (routeParams: RouteParams) => getRoute(CAR_QUOTE_PAYMENT_PAGE_URL, { routeParams });
